import FieldCustomerIdNumber from './FieldCustomerIdNumber';
export default FieldCustomerIdNumber;
